<div directive-height-adjust="target" [addHeight]="minHeight" [targetId]="'modal-'+modalData.id"
    directive-drop-down-outer-click
    class="modal-box{{positionVerticalOffset ? ' -position-vertical-offset-'+positionVerticalOffset : ''}}{{feel ? ' -feel-'+feel : ''}} {{size ? '-size-' + size : ''}}{{modalData.animate ? ' -animate-' + modalData.animate : ''}} {{'-type-' + modalData.type}}{{modalData.feel ? ' -feel-'+modalData.feel : ''}}"
    id="{{'modal-id-' + modalData.id}}"
    [ngClass]="{'-mobile-preserve': mobilePreserve, '-not-mobile-preserved': !mobilePreserve}">
    <div class="modal-box__inner">
        <ng-content></ng-content>
    </div>
</div>